import React from 'react';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';

import {
  FlexCenter,
  Header,
  UnlockWithKeyHole,
  Icon,
  COLORS,
} from '@summer/ui-components';

import { SetPasswordForm } from 'components/pages/userIdentityVerification/SetPasswordForm';
import { createAccountRecoveryPassword } from 'redux/actions/accountRecovery.actions';
import { clearServerError } from 'redux/actions/ui.actions';
import { createAccountRecoveryPasswordLabel } from 'redux/middleware/accountRecovery.middleware';
import { getErrorCode, isLoading } from 'redux/selectors/ui.selectors';
import { setPasswordValidationSchema } from 'schemas/user';

const validationSchema = setPasswordValidationSchema;

const errorMessages = new Map([
  [429, 'Too many requests. Please wait for 1 minute before trying again.'],
  [500, 'Something went wrong. Please try again.'],
]);

const AccountRecoveryPasswordForm = ({
  isLoading,
  verifyPasswordErrorCode,
}) => {
  const dispatch = useDispatch();
  const disclaimer =
    'Your new password must be at least 12 characters long, include letters, numbers, and special characters, and must not reuse any previous passwords, including work passwords.';

  const handleSubmit = values => {
    const { password } = values;
    dispatch(createAccountRecoveryPassword({ password }));
  };

  const handlePasswordChange = () => {
    dispatch(clearServerError(createAccountRecoveryPasswordLabel));
  };

  const errorMessage = verifyPasswordErrorCode
    ? errorMessages.get(verifyPasswordErrorCode) ||
      'Something went wrong. Please try again.'
    : null;

  return (
    <Container>
      <StyledIcon SvgComponent={UnlockWithKeyHole} stroke={COLORS.azure} />
      <Title>
        <Header h4 center>
          Set a Password for Future Visits
        </Header>
      </Title>

      <SetPasswordForm
        passwordTitle="Enter Password"
        confirmPasswordTitle="Confirm Password"
        buttonText="Submit Password"
        errorMessage={errorMessage}
        disclaimer={disclaimer}
        onSubmit={handleSubmit}
        handlePasswordChange={handlePasswordChange}
        validationSchema={validationSchema}
        isLoading={isLoading}
      />
    </Container>
  );
};

const Container = styled(FlexCenter)`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  padding: 0 24px;
`;

const StyledIcon = styled(Icon)`
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
`;

const Title = styled.div`
  margin-bottom: 20px;
`;

const mapStateToProps = state => ({
  isLoading: isLoading(state, 'reset'),
  verifyPasswordErrorCode: getErrorCode(
    state,
    createAccountRecoveryPasswordLabel,
  ),
});

export default connect(mapStateToProps)(AccountRecoveryPasswordForm);
